
<template>
  <div id="debug_tool">
    <h1>Инструменты отладки</h1>
    <div>
      <v-tabs
          v-model="current_tab_index"
          style="margin-top: 15px;"
          background-color="transparent"
          center-active
          show-arrows
          @change="choose_log"
      >
        <v-tab v-for="tab in tabs_list" :key="tab.tab">
          <span class="tab-font" >{{ tab.content }}</span>
        </v-tab>
      </v-tabs>
      <v-row justify="space-between" >
      <v-btn v-if="!this.real_time"
            elevation="2" color="primary" style="margin-left:30px"
            @click="call_filter()"
          >{{this.show_filer === true ? "Скрыть фильтры" : "Показать фильтры"}}
      </v-btn>
      <v-btn
            elevation="2" color="primary" style="margin-left:30px"
            @click="call_realtime()"
          >{{this.real_time === true ? "Отключить отображение в реальном времени" : "Включить отображение в реальном времени"}}
      </v-btn> 
      </v-row>     
        <v-row justify="space-between" >
          <div>
            <v-text-field v-if="show_filer"
              v-model="str_search"
              style="margin-left:250px;"
              label="Поиск"
            ></v-text-field>
         
          </div>
          
            
          <div style="margin-bottom:40px" v-if="show_filer">
                
                <v-menu
                  v-model="menu_df"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="from_date"
                      label="Дата от"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="from_date"
                    @input="menu_df = false; input_from_date(from_date)"
                  ></v-date-picker>
                </v-menu>
         
                 <v-menu
                  ref="menu_tf"
                  v-model="menu_tf"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="from_time"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="from_time"
                      label="Время от"
                      prepend-icon="mdi-clock-time-four-outline"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="menu_tf"
                    v-model="from_time"
                    full-width
                    format="24hr"
                    @click:minute="input_from_time(from_time); $refs.menu_tf.save(from_time)"
                  ></v-time-picker>
               </v-menu>
              </div>
            <div v-if="show_filer">
                <v-menu
                  v-model="menu_dt"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="to_date"
                      label="Дата до"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="to_date"
                    @input="menu_dt = false; input_to_date(to_date)"
                  ></v-date-picker>
                </v-menu>
         
                <v-menu
                  ref="menu_tt"
                  v-model="menu_tt"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="to_time"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="to_time"
                      label="Время до"
                      prepend-icon="mdi-clock-time-four-outline"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="menu_tt"
                    v-model="to_time"
                    full-width
                    format="24hr"
                    @click:minute="input_to_time(to_time); $refs.menu_tt.save(to_time)"
                  ></v-time-picker>
               </v-menu>
              
              </div>
              
          <div>
            
           <v-select
            v-if="!this.real_time"
            :items="items"
            label="Количество строк"
            @change="setrowscount"
          ></v-select>
           <div>
          <v-btn
          color="primary"
          v-if="show_filer"
          @click="search_text()"
          >
                Поиск
              </v-btn>
          </div>
          </div>
          </v-row>
        <v-textarea v-if = "log_text || waiting_for_server_response"
          v-bind:label= "this.log_texts_info"
          row-height="15"
          hide-details
          outlined
          readonly
          filled
          no-resize
          rows="20"
          :value="log_text"
          style="margin-top: 20px"
        >
        </v-textarea>
        
        <v-row justify="center" v-else 
            >
          <v-progress-circular 
            
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-row>
        <v-pagination v-if="log_text && pagination_lenght && !this.real_time" 
          style="padding-top: 10px"
          v-model="current_page"
          :length="this.pagination_lenght"
          total-visible="7"
          @input="get_current_page"
        />
  </div>
  </div>
</template>

<script>
import {EventBus} from "@/bus"
import {mapActions} from "vuex";
export default {
  name: "DebugTool",
  data: function () {
    EventBus.$on('ws_on_message', this.ws_on_message)
    return {
      current_tab_index: 0,
      tabs_list: [
        {tab: 'sender', content: 'Распознавание'},
        {tab: 'conns/devices_network_conn', content: 'Master-slave'},
        {tab: 'conns/external_conn', content: 'Прочие соединения'},
        {tab: 'cams', content: 'Камера'},
        {tab: 'file_manager', content: 'Изображения OpenCV'},
        {tab: 'system_utils', content: 'Системные службы'},
        {tab: 'socketio_server_namespaces/lpr_devices_manager_namespace', content: ' Сервер, работающий со слейвами (SocketIO)'},
        {tab: 'socketio_server_namespaces/viport_manager_namespace', content: ' Сервер, работающий с Viport (SocketIO)'},
        {tab: 'excel_handler', content: 'Excel парсер'},
        {tab: 'event_handler', content: 'Обработчик, считанных номеров'},
        {tab: 'cron_handler', content: 'Периодические события'},
        {tab: 'scoreboard_handler', content: 'Таблоиды'},
        {tab: 'network_settings_utils', content: 'Установка параметров сети'},
        {tab: 'conns/viports_conn', content: 'Соединения Viport'},
        {tab: 'base', content: 'Остальные логи'},
        
    

      ],
      menu_tt: false,
      menu_tf: false,
      menu_dt: false,
      menu_df: false,

      items: [100, 200, 300, 500],

      log_text: '',
      current_page: 1,
      pagination_lenght: 10,
      rowscount:100,
      log_type: 0,
      from_date: new Date().toISOString().substr(0, 10),
      from_time:"",
      to_date: new Date().toISOString().substr(0, 10),
      to_time:"",
      str_search:"",
      show_filer: false,
      real_time: false,
      log_texts_info: "",
      waiting_for_server_response: false
      //real_time_rows: 1
    }
  },
  methods: {
    ws_on_message: function (message) {

          message = JSON.parse(message)
          let method = message.method
            let params = message.params
            if (method === 'get_logs') {
              if (!this.real_time) {
                 this.pagination_lenght = params["pagination"]
                this.log_text += params["data"]
              }
               
            }
            if (method === 'get_logs_waiting_response'){
              this.waiting_for_server_response = true
              this.log_texts_info = "Соединение установлено. Ожидаем логов"
            }
            if (method === 'get_logs_real_time') {
              if (this.waiting_for_server_response) {
                this.log_texts_info = "Тексты логов"
                this.rowscount +=1
                this.setrowscount(this.rowscount)
                this.log_text = this.log_text.replace(/^/,params+ "\n")
              }
            }
        },
    sendmsg: function(datetime){
          this.log_texts_info = "Тексты логов"
          if (datetime) {
              this.sendSocketMessage(
                {
                  method: "logs_showing",
                  params: {
                    "log_type": this.tabs_list[this.log_type]["tab"],
                    "page": this.current_page-1,
                    "reverse": 1,
                    "rowscount": this.rowscount,
                    "date_from": this.from_date,
                    "date_to": this.to_date,
                    "time_from": this.from_time,
                    "time_to":this.to_time,
                    "str_search": this.str_search
                  }
                }
              ) 
              this.log_text =''
          }
          else{
            this.sendSocketMessage(
              {
                method: "logs_showing",
                params: {
                  "log_type": this.tabs_list[this.log_type]["tab"],
                  "page": this.current_page-1,
                  "reverse": 1,
                  "rowscount": this.rowscount
                }
              }
            )
            this.log_text =''
          }
        },
    get_current_page(page){
      if (this.show_filer) {
        this.current_page = page
        this.sendmsg(true)  
      }
      else{
        this.current_page = page
        this.sendmsg(false)
      }
      
    },
    setrowscount(count){
      if (this.show_filer) {
        this.rowscount = count
        this.sendmsg(true)
      }
      else{
        if (this.real_time) {
          this.rowscount = count
        }
        else{
          this.rowscount = count
          this.sendmsg(false)
        }
        
      }
        
    },
    choose_log(log){
      this.waiting_for_server_response = false
      this.log_type = log
      this.current_page = 1
      this.current_page = 1
      this.log_text = ""
      if (this.real_time) {
        this.sendSocketMessage(
          {
            method: "real_time_logs",
             params: {
               "log_type": this.tabs_list[this.log_type]["tab"]
               }
          }
        )
      }
      else{
        this.sendmsg(false)
      }
      

    },
    input_from_date: function (params) {
        this.from_date = params
        this.current_page = 1
      },
    input_from_time: function (params) {
        this.from_time = params + ':00'
        this.current_page = 1
      },
    input_to_date: function (params) {
        this.to_date = params
        this.current_page = 1
      },
    input_to_time: function (params) {
        this.to_time = params + ':00'
        this.current_page = 1
      },
    search_text(){
      this.current_page = 1
      this.sendmsg(true)

    },
    call_filter(){
      this.show_filer = !this.show_filer
      if (!this.show_filer) {
        this.from_date = ""
        this.to_date = ""
        this.from_time = ""
        this.to_time = ""
        
      }
    },
    call_realtime(){
      
      this.rowscount = 1
      this.log_text =''
      this.real_time = !this.real_time
      this.show_filer = false
      this.from_date = ""
      this.to_date = ""
      this.from_time = ""
      this.to_time = ""
      this.str_search = ""
      if (this.real_time){
        this.sendSocketMessage(
          {
            method: "real_time_logs",
            params: {
              "log_type": this.tabs_list[this.log_type]["tab"]
            }
          }
        )
      }
      else {
          // this.$store.dispatch('sendSocketMessage', {method: "real_time_logs", params: {"log_type": 16}})
          this.sendSocketMessage(
              {
                method: "real_time_logs",
                params: {
                  "log_type": "off"
                }
              }
          )
          this.rowscount = 100
          this.sendmsg(false)
          
      }
    },
    ...mapActions(['sendSocketMessage'])
  },
  created () {
      this.sendmsg(false)  
  },
  beforeDestroy() {
      this.sendSocketMessage(
              {
                method: "real_time_logs",
                params: {
                  "log_type": "off"
                }
              }
          )
    }
}
</script>g

<style>


</style>